import { render, staticRenderFns } from "./FactorScoringOptions.vue?vue&type=template&id=b6c8a030&scoped=true&"
import script from "./FactorScoringOptions.vue?vue&type=script&lang=ts&"
export * from "./FactorScoringOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c8a030",
  null
  
)

export default component.exports